import { useState, useEffect, useRef } from "react";
import { testPolicy } from "../../dictionary";
import { useLocation } from 'react-router-dom';
import { TooltipComponent, TooltipComponentMobile } from "../../Tooltip";

const TestPolicy = ({ setTestPolicyFilter, setTestPolicyParams, resetStateToggle, mobile }) => {

  const location = useLocation()
  const [testPolicySelect, setTestPolicySelect] = useState<any>('All')
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setTestPolicySelect('All');
  }, [resetStateToggle]);

  const handleTestPolicyChange = (event) => {
    const selectedTestPolicy = event.target.value
    setTestPolicySelect(selectedTestPolicy)
    setTestPolicyFilter(testPolicy[selectedTestPolicy])
  }

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let testPolicyParam = params.get('testPolicy');

    if (testPolicyParam) {
      setTestPolicySelect(testPolicyParam)
      setTestPolicyFilter(testPolicy[testPolicyParam])
    }

    else {
      setTestPolicySelect('All')
      setTestPolicyFilter('')
    }

  }, [location.search]);

  useEffect(() => {

    let params = new URLSearchParams(location.search);

    if (testPolicySelect != 'All') {
      params.set('testPolicy', testPolicySelect)
    } else {
      params.delete('testPolicy')
    }

    setTestPolicyParams(`${params.toString()}`)

  }, [testPolicySelect])

  return <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
    <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>TEST POLICY {mobile ? <span className="ms-2"><TooltipComponentMobile content={"Test policy reflects each college's approach to testing for the 2025-2026 application cycle (i.e. students starting in Fall of 2026.) Policies may change so we recommend confirming via the college's admissions website when applying."} /></span> : <TooltipComponent content={"Test policy reflects each college's approach to testing for the 2025-2026 application cycle (i.e. students starting in Fall of 2026.) Policies may change so we recommend confirming via the college's admissions website when applying."} />}</div>
    <select
      className='form-select form-select-solid'
      data-control="select2"
      value={testPolicySelect}
      onChange={handleTestPolicyChange}
      style={{ cursor: 'pointer' }}
    >
      <option value={Object.keys(testPolicy)[0]}>{Object.keys(testPolicy)[0]}</option>
      <option value={Object.keys(testPolicy)[1]}>{Object.keys(testPolicy)[1]}</option>
      <option value={Object.keys(testPolicy)[2]}>{Object.keys(testPolicy)[2]}</option>
      <option value={Object.keys(testPolicy)[3]}>{Object.keys(testPolicy)[3]}</option>
    </select>
  </div>
}

export { TestPolicy }